package dev.terrakok.mapitan.ui.components

import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Path
import androidx.compose.ui.graphics.drawscope.DrawScope
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.unit.DpRect
import androidx.compose.ui.unit.DpSize
import androidx.compose.ui.unit.dp
import org.maplibre.compose.util.ImageStretch

val LABEL_BUBBLE_SIZE = DpSize(30.dp, 30.dp)

val LABEL_BUBBLE_STRETCH = ImageStretch(
    x = listOf(7.5.dp..9.5.dp, 20.5.dp..22.5.dp),
    y = listOf(6.dp..17.dp),
    content = DpRect(4.dp, 3.dp, 26.dp, 21.dp),
)

val LABEL_SELECTION_STRETCH = ImageStretch.capInsets(
    left = 12.dp,
    top = 12.dp,
    right = 12.dp,
    bottom = 12.dp,
)

class LabelBubblePainter(
    private val borderColor: Color,
) : Painter() {
    override val intrinsicSize: Size = Size.Unspecified

    override fun DrawScope.onDraw() {
        val strokeWidth = 2.dp.toPx()
        val inset = strokeWidth / 2f
        val radius = 5.dp.toPx()
        val left = inset
        val top = inset
        val right = size.width - inset
        val bodyBottom = size.height - 8.dp.toPx()
        val tipBottom = size.height - inset
        val centerX = size.width / 2f
        val tailHalfWidth = 5.dp.toPx()
        val path = Path().apply {
            moveTo(left, top + radius)
            quadraticTo(left, top, left + radius, top)
            lineTo(right - radius, top)
            quadraticTo(right, top, right, top + radius)
            lineTo(right, bodyBottom - radius)
            quadraticTo(right, bodyBottom, right - radius, bodyBottom)
            lineTo(centerX + tailHalfWidth, bodyBottom)
            lineTo(centerX, tipBottom)
            lineTo(centerX - tailHalfWidth, bodyBottom)
            lineTo(left + radius, bodyBottom)
            quadraticTo(left, bodyBottom, left, bodyBottom - radius)
            close()
        }
        val shadowPath = Path().apply {
            addPath(path, Offset(0f, 1.dp.toPx()))
        }
        drawPath(shadowPath, Color.Black.copy(alpha = 0.16f))
        drawPath(path, Color.White)
        drawPath(path, borderColor, style = Stroke(strokeWidth))
    }
}
